export default "__VITE_ASSET__0200ceac__"